var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useState } from 'react';
import styled from 'styled-components';
import { Box, Button, CheckmarkOutlinedIcon, DownCaretIcon, MenuItem, Radio, RadioGroup, theme as dsTheme, Typography, WarningOutlinedIcon, TrashOutlinedIcon, IconButton, Dialog, DialogActions, } from '@kareo/design-system';
import { FormControlLabel, Grid, Menu, Divider } from '@material-ui/core';
import CardTypeDisplay from './CardTypeDisplay';
import CardDetailsContext from '../PaymentSolutions/CollectPayment/CardDetailsContext';
var theme = dsTheme;
var ContainerStyled = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & + & {\n    margin-top: 1rem;\n  }\n"], ["\n  & + & {\n    margin-top: 1rem;\n  }\n"])));
var FormControlLabelStyled = styled(FormControlLabel)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n\n  // sorry for this weird css, for some reason the regular selector isn't working\n  span:nth-child(2) {\n    width: 100%;\n  }\n\n  .MuiFormControlLabel-root {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n\n  // sorry for this weird css, for some reason the regular selector isn't working\n  span:nth-child(2) {\n    width: 100%;\n  }\n\n  .MuiFormControlLabel-root {\n    width: 100%;\n  }\n"])));
var RadioStyled = styled(Radio)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: flex-start;\n"], ["\n  align-self: flex-start;\n"])));
function formatBillingAddress(billingAddress, billingCity, billingState, billingZip) {
    var formattedAddress = '';
    if (!!billingAddress) {
        formattedAddress += billingAddress + ' ';
    }
    if (!!billingCity) {
        formattedAddress += billingCity + ', ';
    }
    if (!!billingState) {
        formattedAddress += billingState + ' ';
    }
    if (!!billingZip) {
        formattedAddress += billingZip + ' ';
    }
    return formattedAddress;
}
function isCardExpiringSoon(expirationMonth, expirationYear) {
    var currentDate = new Date();
    // Returns 0-11
    var currentMonth = currentDate.getMonth() + 1;
    var currentYear = currentDate.getFullYear() % 100;
    // Cards expiring in January should start showing expiring soon in December of the previous year.
    var shouldShowDecemberExpiringSoon = expirationYear - 1 === currentYear &&
        expirationMonth === 1 &&
        currentMonth === 12;
    var shouldShowExpiringSoon = currentYear === expirationYear &&
        (currentMonth === expirationMonth - 1 || currentMonth === expirationMonth);
    // Start raising expiring soon one month before expiration month.
    return shouldShowExpiringSoon || shouldShowDecemberExpiringSoon;
}
function isCardExpired(expirationMonth, expirationYear) {
    var currentDate = new Date();
    // Returns 0-11
    var currentMonth = currentDate.getMonth() + 1;
    var currentYear = currentDate.getFullYear() % 100;
    var expiredDueToYear = currentYear > expirationYear;
    var expiredDueToMonth = currentYear === expirationYear && currentMonth > expirationMonth;
    return expiredDueToYear || expiredDueToMonth;
}
var CardListConfigContext = createContext({
    showRadioSelector: false,
    shouldRenderCardDescription: false,
    shouldRenderActions: false,
    shouldShowDeleteCardButton: true,
});
// ---
function CardInfoDisplay(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var cardNickname = props.cardNickname, cardType = props.cardType, last4 = props.last4, expMonth = props.expMonth, expYear = props.expYear, defaultCard = props.defaultCard, showCardDetails = props.showCardDetails, setShowCardDetails = props.setShowCardDetails, hoveringOverDelete = props.hoveringOverDelete, setHoveringOverDelete = props.setHoveringOverDelete, setShowDeleteConfirmationModal = props.setShowDeleteConfirmationModal, cardId = props.cardId, setCardIdToBeDeleted = props.setCardIdToBeDeleted;
    var _k = useContext(CardListConfigContext), shouldRenderActions = _k.shouldRenderActions, shouldShowDeleteCardButton = _k.shouldShowDeleteCardButton;
    var _l = useState(null), anchorEl = _l[0], setAnchorEl = _l[1];
    var open = Boolean(anchorEl);
    var showExpiringSoon = isCardExpiringSoon(expMonth, expYear);
    var showExpired = isCardExpired(expMonth, expYear);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleSetAnchorEl = function () {
        setAnchorEl(null);
    };
    var handleShowCardDetails = function () {
        handleSetAnchorEl();
        setShowCardDetails(true);
    };
    var handleHideCardDetails = function () {
        handleSetAnchorEl();
        setShowCardDetails(false);
    };
    var handleOpenDeleteConfirmationModal = function () {
        setShowDeleteConfirmationModal(true);
        setCardIdToBeDeleted(cardId === null || cardId === void 0 ? void 0 : cardId.toString());
    };
    return (React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
        React.createElement(Grid, { item: true },
            React.createElement(Box, { display: "flex", width: "32px", height: "32px" },
                React.createElement(CardTypeDisplay, { type: cardType }))),
        React.createElement(Grid, { item: true },
            React.createElement(Box, { fontWeight: "fontWeightBold" }, cardNickname || (cardType === null || cardType === void 0 ? void 0 : cardType.toLocaleUpperCase()))),
        React.createElement(Grid, { item: true }, "- " + last4),
        React.createElement(Grid, { item: true }, "(Exp " + expMonth + "/" + expYear + ")"),
        showExpiringSoon && !showExpired && (React.createElement(Grid, { item: true, style: {
                color: (_b = (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.vitality) === null || _b === void 0 ? void 0 : _b.main,
                display: 'contents',
                fontSize: '14px',
            } },
            React.createElement("div", { style: { display: 'contents' } },
                React.createElement(WarningOutlinedIcon, { fontSize: "xsmall" })),
            React.createElement("b", { style: { marginLeft: '5px', marginTop: '1px' } }, "Expiring Soon"))),
        showExpired && !showExpiringSoon && (React.createElement(Grid, { item: true, style: {
                color: (_d = (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.dark,
                display: 'contents',
                fontSize: '14px',
            } },
            React.createElement("div", { style: { display: 'contents' } },
                React.createElement(WarningOutlinedIcon, { fontSize: "xsmall" })),
            React.createElement("b", { style: { marginLeft: '5px', marginTop: '1px' } }, "Expired"))),
        shouldShowDeleteCardButton && (React.createElement(Box, { marginLeft: "auto", display: "flex", alignItems: "baseline", color: (_f = (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.primary) === null || _f === void 0 ? void 0 : _f.main },
            React.createElement(IconButton, { onClick: handleOpenDeleteConfirmationModal, onMouseEnter: function () { return setHoveringOverDelete(true); }, onMouseLeave: function () { return setHoveringOverDelete(false); } },
                React.createElement(TrashOutlinedIcon, { onMouseEnter: function () { return setHoveringOverDelete(true); }, onMouseLeave: function () { return setHoveringOverDelete(false); }, fontSize: "small", color: hoveringOverDelete ? 'error' : undefined })))),
        shouldRenderActions && (React.createElement(Box, { marginLeft: "auto", display: "flex", alignItems: "baseline", color: (_h = (_g = theme.palette) === null || _g === void 0 ? void 0 : _g.primary) === null || _h === void 0 ? void 0 : _h.main },
            defaultCard && (React.createElement(React.Fragment, null,
                React.createElement(CheckmarkOutlinedIcon, { fontSize: "xxsmall" }),
                React.createElement(Box, { marginLeft: "3px", width: "50px", height: "20px", fontWeight: "700" }, "Default"))),
            React.createElement(Box, { marginLeft: "20px" },
                React.createElement(Button, { id: "basic-button", "aria-controls": open ? 'basic-menu' : undefined, "aria-expanded": open ? 'true' : undefined, variant: "text", onClick: handleClick, disableRipple: true, endIcon: React.createElement(DownCaretIcon, { fontSize: "xsmall" }) }, "Actions")),
            React.createElement(Menu, { id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleSetAnchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, MenuListProps: {
                    style: {
                        padding: 0,
                        margin: 0,
                    },
                } },
                React.createElement(MenuItem, { onClick: handleSetAnchorEl }, "Edit Card"),
                !showCardDetails && (React.createElement(MenuItem, { onClick: handleShowCardDetails }, "Show Details")),
                showCardDetails && (React.createElement(MenuItem, { onClick: handleHideCardDetails }, "Hide Details")),
                React.createElement(MenuItem, { onClick: handleSetAnchorEl },
                    React.createElement(Box, { color: (_j = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _j === void 0 ? void 0 : _j.secondary.dark }, "Remove Card")))))));
}
function DefinitionItem(props) {
    return React.createElement(Grid, __assign({ container: true, xs: 12, direction: "row" }, props));
}
function DefinitionTerm(props) {
    return (React.createElement(Grid, { item: true, xs: 2 },
        React.createElement(Typography, __assign({ component: "span", variant: "body2" }, props))));
}
function DefinitionDescription(props) {
    return (React.createElement(Grid, { item: true, xs: 10 },
        React.createElement(Typography, __assign({ component: "span", variant: "body2" }, props))));
}
function CardDetailsDisplay(props) {
    var billingAddress = props.billingAddress, billingCity = props.billingCity, billingState = props.billingState, billingZip = props.billingZip, cardDescription = props.cardDescription, expMonth = props.expMonth, expYear = props.expYear, last4 = props.last4;
    var isCardDescriptionPresent = !!cardDescription && cardDescription.length > 0;
    var formattedBillingAddress = formatBillingAddress(billingAddress, billingCity, billingState, billingZip);
    var isBillingAddressPresent = formattedBillingAddress.length > 0;
    return (React.createElement(Grid, { container: true, style: { marginLeft: 40 }, component: "dl" },
        isBillingAddressPresent && (React.createElement(DefinitionItem, null,
            React.createElement(DefinitionTerm, null, "Billing Address"),
            React.createElement(DefinitionDescription, null, formattedBillingAddress))),
        isCardDescriptionPresent && (React.createElement(DefinitionItem, null,
            React.createElement(DefinitionTerm, null, "Comments"),
            React.createElement(DefinitionDescription, null, cardDescription))),
        React.createElement(DefinitionItem, null,
            React.createElement(DefinitionTerm, null, "Number"),
            React.createElement(DefinitionDescription, null,
                "Ending in ",
                last4)),
        React.createElement(DefinitionItem, null,
            React.createElement(DefinitionTerm, null, "Expiration Date"),
            React.createElement(DefinitionDescription, null,
                expMonth,
                "/",
                expYear))));
}
function SavedCardInner(props) {
    var cardDescription = props.cardDescription;
    var shouldRenderCardDescription = useContext(CardListConfigContext).shouldRenderCardDescription;
    var _a = useState(false), showCardDetails = _a[0], setShowCardDetails = _a[1];
    var isCardDescriptionPresent = !!cardDescription && cardDescription.length > 0;
    return (React.createElement(Box, { width: "100%", display: "flex", flexDirection: "column" },
        React.createElement(CardInfoDisplay, __assign({ showCardDetails: showCardDetails, setShowCardDetails: setShowCardDetails }, props)),
        isCardDescriptionPresent &&
            !showCardDetails &&
            shouldRenderCardDescription && (React.createElement(Typography, { variant: "body2", component: "span", style: { marginLeft: '40px' } }, cardDescription)),
        showCardDetails && (React.createElement(CardDetailsDisplay, __assign({}, props, { showCardDetails: showCardDetails })))));
}
export function SavedCardListItem(props) {
    var _a, _b, _c;
    var _d = useState(false), hoveringOverDelete = _d[0], setHoveringOverDelete = _d[1];
    var showRadioSelector = useContext(CardListConfigContext).showRadioSelector;
    return (React.createElement(ContainerStyled, { paddingTop: 1, paddingBottom: 1, paddingLeft: 2, paddingRight: 2, border: 1, borderColor: hoveringOverDelete
            ? (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.error.main : (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.grey[500], borderRadius: "5px", style: {
            backgroundColor: hoveringOverDelete
                ? (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.vitality[100] : undefined,
        } },
        showRadioSelector && (React.createElement(FormControlLabelStyled, { disabled: props.disabled, value: props.cardId, control: React.createElement(RadioStyled, null), label: React.createElement(SavedCardInner, __assign({ setHoveringOverDelete: setHoveringOverDelete, hoveringOverDelete: hoveringOverDelete }, props)) })),
        !showRadioSelector && (React.createElement(SavedCardInner, __assign({ setHoveringOverDelete: setHoveringOverDelete, hoveringOverDelete: hoveringOverDelete }, props)))));
}
export function SavedCardList(props) {
    var _a, _b, _c, _d;
    var _e = props.cards, cards = _e === void 0 ? [] : _e, disabled = props.disabled, config = props.config;
    var _f = useContext(CardDetailsContext), selectedCard = _f.selectedCard, setSelectedCard = _f.setSelectedCard, patient = _f.patient, deleteCard = _f.deleteCard;
    var _g = useState(false), showDeleteConfirmationModal = _g[0], setShowDeleteConfirmationModal = _g[1];
    var _h = useState(''), cardIdToBeDeleted = _h[0], setCardIdToBeDeleted = _h[1];
    var handleDeleteCardOnFile = function () {
        if (cardIdToBeDeleted !== undefined && patient.patientId !== -1) {
            deleteCard(cardIdToBeDeleted);
            setShowDeleteConfirmationModal(false);
        }
    };
    function onChangeSelectedCard(evt, value) {
        var cardData = cards.find(function (card) { return card.cardId.toString() === value; });
        if (cardData !== undefined) {
            setSelectedCard(cardData);
        }
    }
    var inferredConfig = {
        shouldRenderActions: (_a = config === null || config === void 0 ? void 0 : config.shouldRenderActions) !== null && _a !== void 0 ? _a : false,
        shouldRenderCardDescription: (_b = config === null || config === void 0 ? void 0 : config.shouldRenderCardDescription) !== null && _b !== void 0 ? _b : false,
        showRadioSelector: (_c = config === null || config === void 0 ? void 0 : config.showRadioSelector) !== null && _c !== void 0 ? _c : false,
        shouldShowDeleteCardButton: (_d = config === null || config === void 0 ? void 0 : config.shouldShowDeleteCardButton) !== null && _d !== void 0 ? _d : true,
    };
    return (React.createElement("div", null,
        showDeleteConfirmationModal && (React.createElement(Dialog, __assign({}, props, { open: showDeleteConfirmationModal, onClose: function () { return setShowDeleteConfirmationModal(false); }, "aria-labelledby": "cta-dialog-title" }),
            React.createElement("div", { style: { margin: '8px 16px' } },
                React.createElement(Typography, { variant: "h2" }, "Delete Card?"),
                React.createElement(Typography, { variant: "body1" }, "This will delete the card on file permanently.")),
            React.createElement(Divider, { style: { height: '1px' } }),
            React.createElement(DialogActions, null,
                React.createElement(Box, null,
                    React.createElement(Button, { onClick: function () { return setShowDeleteConfirmationModal(false); }, variant: "text", color: "vitality" }, "Cancel"),
                    React.createElement(Button, { onClick: handleDeleteCardOnFile, color: "vitality" }, "Delete"))))),
        React.createElement(CardListConfigContext.Provider, { value: inferredConfig },
            React.createElement(RadioGroup, { value: (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.cardId) || null, onChange: onChangeSelectedCard }, cards.map(function (data) { return (React.createElement(SavedCardListItem, __assign({ key: "card-" + data.cardId + "-key", setShowDeleteConfirmationModal: setShowDeleteConfirmationModal, setCardIdToBeDeleted: setCardIdToBeDeleted, disabled: disabled }, data))); })))));
}
export default SavedCardList;
var templateObject_1, templateObject_2, templateObject_3;
